var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4143 2.91822L9.08209 0.585813C8.70703 0.210719 8.19834 0 7.66791 0H2C0.895437 0 0 0.895437 0 2L0.000625 14C0.000625 15.1046 0.896031 16 2.00062 16H10C11.1 16 12 15.1 12 14V4.33247C12 3.80203 11.7893 3.29331 11.4143 2.91822ZM10.0001 14.5H2.00053C1.72441 14.5 1.50053 14.2762 1.50053 14L1.50003 2.00394C1.5 1.72778 1.72387 1.50391 2.00003 1.50391H7.00025V4C7.00025 4.55228 7.44797 5 8.00025 5H10.5001V14C10.5001 14.2762 10.2762 14.5 10.0001 14.5Z",
    fill: "currentcolor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentAlt);
export default __webpack_public_path__ + "static/media/document-alt.2943dea4.svg";
export { ForwardRef as ReactComponent };